"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPopoverProps = exports.defaultDateTimeInputProps = exports.defaultDateTimeAriaLabels = exports.datePickerDefaultProps = exports.POPOVER_PADDING = exports.POPOVER_MAX_WIDTH = exports.ISO_FORMAT = exports.INSET_ELEMENT_DEFAULTS = exports.CALENDAR_WRAPPER_PADDING = exports.CALENDAR_WRAPPER_MAX_WIDTH = exports.CALENDAR_WIDTH = exports.CALENDAR_CELL_SIZE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _popover = require("../../popover");

var _utils = require("../../utils");

var _constants = require("../time-picker/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// YYYY-MM-DDTHH:MM:SS.SSSZ
// Ex: 2020-01-30T15:59:59.000Z
var ISO_FORMAT = /(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/;
exports.ISO_FORMAT = ISO_FORMAT;
var INSET_ELEMENT_DEFAULTS = {
  width: _utils.A11Y_MIN_SIZE,
  inset: 4
};
exports.INSET_ELEMENT_DEFAULTS = INSET_ELEMENT_DEFAULTS;
var CALENDAR_CELL_SIZE = 40;
exports.CALENDAR_CELL_SIZE = CALENDAR_CELL_SIZE;
var CALENDAR_WIDTH = 7 * CALENDAR_CELL_SIZE;
exports.CALENDAR_WIDTH = CALENDAR_WIDTH;
var CALENDAR_WRAPPER_PADDING = 16;
exports.CALENDAR_WRAPPER_PADDING = CALENDAR_WRAPPER_PADDING;
var CALENDAR_WRAPPER_MAX_WIDTH = CALENDAR_WIDTH + 2 * CALENDAR_WRAPPER_PADDING;
exports.CALENDAR_WRAPPER_MAX_WIDTH = CALENDAR_WRAPPER_MAX_WIDTH;
var POPOVER_PADDING = 16;
exports.POPOVER_PADDING = POPOVER_PADDING;
var POPOVER_MAX_WIDTH = CALENDAR_WRAPPER_MAX_WIDTH;
exports.POPOVER_MAX_WIDTH = POPOVER_MAX_WIDTH;

var defaultDateTimeAriaLabels = _objectSpread(_objectSpread({
  year: 'Year',
  month: 'Month',
  day: 'Day'
}, _constants.defaultTimeAriaLabels), {}, {
  increase: _objectSpread({
    year: 'Next year',
    month: 'Next month',
    day: 'Next day'
  }, _constants.defaultTimeAriaLabels.increase),
  decrease: _objectSpread({
    year: 'Previous year',
    month: 'Previous month',
    day: 'Previous day'
  }, _constants.defaultTimeAriaLabels.decrease)
});

exports.defaultDateTimeAriaLabels = defaultDateTimeAriaLabels;
var defaultPopoverProps = {
  shouldFocusOnOpen: false,
  position: _popover.PopoverPosition.BottomTrailing
};
exports.defaultPopoverProps = defaultPopoverProps;
var datePickerDefaultProps = {
  weekStartDay: 0,
  'aria-label': 'Date selection'
};
exports.datePickerDefaultProps = datePickerDefaultProps;

var defaultDateTimeInputProps = _objectSpread(_objectSpread({}, datePickerDefaultProps), {}, {
  calendarButtonAltText: 'Date time picker',
  collapsedTitleText: 'Select a date and time',
  collapsedCloseButtonAltText: 'Close date time picker',
  ariaLabels: defaultDateTimeAriaLabels,
  popoverProps: defaultPopoverProps
});

exports.defaultDateTimeInputProps = defaultDateTimeInputProps;